import gql from 'graphql-tag'

export const LOGIN = gql`
  mutation login(
    $client_id: String!
    $client_secret: String!
    $grant_type: GrantType!
    $username: String!
    $password: String!
  ) {
    login(input: {
      client_id: $client_id
      client_secret: $client_secret
      grant_type: $grant_type
      username: $username
      password: $password
    }) {
      createdAccessToken {
        access_token
        refresh_token
      }
      success
      message
    }
  }
`

export const REQ_RESET_PASSWORD_TOKEN = gql`
  mutation forgetPassword(
    $email: String!
  ) {
    forgetPassword(input: {
      email: $email
    }) {
      createdForgetPassword {
        resetPasswordToken
      }
      success
      message
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation resetPassword(
    $token: String!
    $newPassword: String!
  ) {
    resetPassword(input: {
      token: $token
      newPassword: $newPassword
    }) {
      success
      message
    }
  }
`

export const CREATE_USER = gql`
  mutation createUser(
    $firstName: String!
    $lastName: String!
    $password: String!
    $email: String!
    $roles: [Int]!
  ) {
    createUser(input: {
      firstName: $firstName
      lastName: $lastName
      password: $password
      email: $email
      roles: $roles
    }) {
      success
      message
    }
  }
`

export const APPROVE_TIRE_PATCH = gql`
  mutation ApproveTirePatchLog(
    $id: Int!
    $isApprove: Boolean
    $rejectReason: String
  ) {
    ApproveTirePatchLog(input:{
    id: $id
    isApprove: $isApprove
    rejectReason: $rejectReason
    }) {
      success
      message
    }
  }
`

export const PAY_TIRE_PATCH = gql`
  mutation PayTirePatchLog(
    $id: Int!
    $paidType: TirePatchLogPaidType!
    $paidDate: Date!
    $totalPaid: Float!
    $files: [Upload]
  ) {
    PayTirePatchLog(input: {
      id: $id
      paidType: $paidType
      paidDate: $paidDate
      totalPaid: $totalPaid
      files: $files
    }) {
      success
      message
    }
  }
`

export const SWAP_TRUCK_TIRE = gql`
  mutation SwitchTruckTire(
    $id: Int!
    $wheelNo: String!
  ) {
    SwitchTruckTire(input:{
      id: $id
      wheelNo: $wheelNo
    }) {
      success
      message
    }
  }
`

export const SWAP_TRAILER_TIRE = gql`
  mutation SwitchTrailerTire(
    $id: Int!
    $wheelNo: String!
  ) {
    SwitchTrailerTire(input:{
      id: $id
      wheelNo: $wheelNo
    }) {
      success
      message
    }
  }
`

export const CREATE_TIRE_PATCH = gql`
  mutation CreateTirePatchLog(
    $description: String
    $patchDate: Date
    $price: Float!
    $serialId: Int!
    $driverId: Int!
    $files: [Upload]
    $tirepatchstoreId: Int!
    $type: String
    $truckId: Int
    $trailerId: Int
  ) {
    CreateTirePatchLog(input:{
      description: $description
      patchDate: $patchDate
      price: $price
      serialId: $serialId
      driverId: $driverId
      files: $files
      tirepatchstoreId: $tirepatchstoreId
      type: $type
      truckId: $truckId
      trailerId: $trailerId
    }) {
      success
      message
    }
  }
`

export const UPDATE_TIRE_PATCH = gql`
  mutation UpdateTirePatchLog(
    $id: Int!
    $description: String
    $patchDate: Date
    $price: Float!
    $serialId: Int
    $driverId: Int
    $files: [Upload]
    $tirepatchstoreId: Int!
    $type: String
    $truckId: Int
    $trailerId: Int
  ) {
    UpdateTirePatchLog(input:{
      id: $id
      description: $description
      patchDate: $patchDate
      price: $price
      serialId: $serialId
      driverId: $driverId
      files: $files
      tirepatchstoreId: $tirepatchstoreId
      type: $type
      truckId: $truckId
      trailerId: $trailerId
    }) {
      success
      message
    }
  }
`

export const CREATE_PURCHASE_REQUISITION = gql`
  mutation CreatePurchaseRequest(
    $supplierId: Int!
    $deadlineDate: Date
    $remark: String
    $department: String
    $repairId: Int
    $Items: [AddItemPR!]!
  ) {
    CreatePurchaseRequest(input:{
      deadlineDate: $deadlineDate
      remark: $remark
      repairId: $repairId
      Items: $Items
      supplierId: $supplierId
      department: $department
    }) {
      success
      message
    }
  }
`

export const UPDATE_PURCHASE_REQUISITION = gql`
  mutation UpdatePurchaseRequest(
    $supplierId: Int!
    $id: Int!
    $deadlineDate: Date
    $department: String
    $remark: String
    $repairId: Int
    $Items: [AddItemPR!]!
  ) {
    UpdatePurchaseRequest(input:{
      id: $id
      deadlineDate: $deadlineDate
      remark: $remark
      repairId: $repairId
      Items: $Items
      supplierId: $supplierId
      department: $department
    }) {
      success
      message
    }
  }
`

export const CANCEL_PURCHASE_REQUISITION = gql`
  mutation DeletePurchaseRequest(
    $id: Int!
  ) {
    DeletePurchaseRequest(input:{
      id: $id
    }) {
      success
      message
    }
  }
`

export const CREATE_SUPPLIER = gql`
  mutation createSupplier(
    $paymentType: PaymentTypes!
    $paymentInfo: [SupplierBankInput]
    # $prefix: String
    $name: String!
    $taxId: String
    # $bankAccountName: String
    # $bankAccountNumber: String
    $isVat: Boolean
    $contactName: String
    $contactPhoneNumber: String
    $contactFaxNumber: String
    $contactEmail: String
    $contactLineId: String
    $contactFacebookName: String
    $contactRemark: String
    # $type: SupplierType!
    $creditTerm: Int
    # $creditLimit: Float
    # $creditUsage: Float
    $addressUrl: String
    $officeTel: String
  ) {
    createSupplier(input: {
      paymentType: $paymentType
      paymentInfo: $paymentInfo
      # prefix: $prefix
      name: $name
      taxId: $taxId
      # bankAccountName: $bankAccountName
      # bankAccountNumber: $bankAccountNumber
      isVat: $isVat
      officeTel: $officeTel
      contactName: $contactName
      contactPhoneNumber: $contactPhoneNumber
      contactFaxNumber: $contactFaxNumber
      contactEmail: $contactEmail
      contactLineId: $contactLineId
      contactFacebookName: $contactFacebookName
      contactRemark: $contactRemark
      # type: $type
      creditTerm: $creditTerm
      # creditLimit: $creditLimit
      # creditUsage: $creditUsage
      addressUrl: $addressUrl
    }) {
      success
      message
      data {
        id
        name
      }
    }
  }
`

export const CREATE_CUSTOMER = gql`
  mutation createCustomer(
    $paymentType: PaymentTypes
    $pricingTypeId: Int
    $bankId: Int
    $prefix: String
    $name: String!
    $taxId: String
    $bankAccountName: String
    $bankAccountNumber: String
    $isVat: Boolean
    $contactName: String
    $contactPhoneNumber: String
    $contactFaxNumber: String
    $contactEmail: String
    $contactLineId: String
    $contactFacebookName: String
    $contactRemark: String
    $creditLimit: Float
    $creditUsage: Float
    $creditTerm: Int
  ) {
    createCustomer(input: {
      paymentType: $paymentType
      pricingTypeId: $pricingTypeId
      bankId: $bankId
      prefix: $prefix
      name: $name
      taxId: $taxId
      bankAccountName: $bankAccountName
      bankAccountNumber: $bankAccountNumber
      isVat: $isVat
      contactName: $contactName
      contactPhoneNumber: $contactPhoneNumber
      contactFaxNumber: $contactFaxNumber
      contactEmail: $contactEmail
      contactLineId: $contactLineId
      contactFacebookName: $contactFacebookName
      contactRemark: $contactRemark
      creditLimit: $creditLimit
      creditUsage: $creditUsage
      creditTerm: $creditTerm
    }) {
      success
      message
    }
  }
`

export const CREATE_PURCHASE_ORDER = gql`
  mutation CreatePurchaseOrder(
    $supplierId: Int!
    $dueDate: Date!
    $orderItemList: [CreateOrderItemPOInput]!
    $paymentType: PaymentTypes!
    $discountType: PurchaseOrderDiscountType
    $discount: Float
    $remark: String
    $files: [Upload]
    $warehouseId: Int!
    $deliveryCost: Float
    $prItemId: Int
    $purchaseDate: Date!
    $companyType: PurchaseOrderCompanyType
    $paymentDueDate: Date
    $vatType: PurchaseOrderVatType
  ) {
    CreatePurchaseOrder(input:{
      supplierId: $supplierId
      dueDate: $dueDate
      orderItemList: $orderItemList
      paymentType: $paymentType
      discountType: $discountType
      discount: $discount
      remark: $remark
      files: $files
      warehouseId: $warehouseId
      deliveryCost: $deliveryCost
      prItemId: $prItemId
      purchaseDate: $purchaseDate
      companyType: $companyType
      paymentDueDate: $paymentDueDate
      vatType: $vatType
    }) {
      success
      message
    }
  }
`

export const CREATE_GOOD_RECEIVED = gql`
  mutation CreateGoodReceive(
    $purchaseorderId: Int!
    $OrderItem: [CreateGoodReceiveOrderItem]!
    $ExtraItem: [CreateExtraGoodReceiveOrderItem]
    $supplierRefId: String
    $remark: String
    $files: [Upload]
  ) {
    CreateGoodReceive(input:{
      purchaseorderId: $purchaseorderId
      OrderItem: $OrderItem
      ExtraItem: $ExtraItem
      supplierRefId: $supplierRefId
      remark: $remark
      files: $files
    }) {
      success
      message
    }
  }
`

export const CREATE_TIRE_GOOD_RECEIVED = gql`
  mutation CreateGoodReceiveTire(
    $purchaseorderId: Int!
    $OrderItem: [CreateGoodReceiveTireOrderItem]!
    # $ExtraItem: [CreateExtraGoodReceiveOrderItem]
    $supplierRefId: String
    $remark: String
    $files: [Upload]
  ) {
    CreateGoodReceiveTire(input:{
      purchaseorderId: $purchaseorderId
      OrderItem: $OrderItem
      # ExtraItem: $ExtraItem
      supplierRefId: $supplierRefId
      remark: $remark
      files: $files
    }) {
      success
      message
    }
  }
`

export const UPDATE_PURCHASE_ORDER = gql`
  mutation UpdatePurchaseOrder(
    $id: Int!
    $orderItemList: [UpdateOrderItemPOInput]
    $dueDate: Date
    $paymentType: PaymentTypes
    $discountType: PurchaseOrderDiscountType
    $discount: Float
    $remark: String
    $files: [Upload]
    $warehouseId: Int
    $deliveryCost: Float
    $paymentDueDate: Date
    $vatType: PurchaseOrderVatType
  ) {
    UpdatePurchaseOrder(input:{
      id: $id
      orderItemList: $orderItemList
      dueDate: $dueDate
      paymentType: $paymentType
      discountType: $discountType
      discount: $discount
      remark: $remark
      files: $files
      warehouseId: $warehouseId
      deliveryCost: $deliveryCost
      paymentDueDate: $paymentDueDate
      vatType: $vatType
    }) {
      success
      message
    }
  }
`

export const CREATE_WAREHOUSE = gql`
  mutation createWarehouse(
    $addressNo: String
    $province: String
    $district: String
    $subDistrict: String
    $postcode: String
    $contactName: String
    $contactPhoneNumber: String
    $contactFaxNumber: String
    $contactEmail: String
    $contactRemark: String
    $warehouseCode: String
    $warehouseName: String
  ) {
    createWarehouse(input: {
      address: {
        addressNo: $addressNo
        province: $province
        district: $district
        subDistrict: $subDistrict
        postcode: $postcode
        contactName: $contactName
        contactPhoneNumber: $contactPhoneNumber
        contactFaxNumber: $contactFaxNumber
        contactEmail: $contactEmail
        contactRemark: $contactRemark
      }
      warehouseCode: $warehouseCode
      warehouseName: $warehouseName
    }) {
      success
      message
    }
  }
`

export const UPDATE_WAREHOUSE = gql`
  mutation updateWarehouse(
    $id: Int!
    $addressNo: String
    $province: String
    $district: String
    $subDistrict: String
    $postcode: String
    $contactName: String
    $contactPhoneNumber: String
    $contactFaxNumber: String
    $contactEmail: String
    $contactRemark: String
    $warehouseCode: String
    $warehouseName: String
  ) {
    updateWarehouse(input: {
      id: $id
      address: {
        addressNo: $addressNo
        province: $province
        district: $district
        subDistrict: $subDistrict
        postcode: $postcode
        contactName: $contactName
        contactPhoneNumber: $contactPhoneNumber
        contactFaxNumber: $contactFaxNumber
        contactEmail: $contactEmail
        contactRemark: $contactRemark
      }
      warehouseCode: $warehouseCode
      warehouseName: $warehouseName
    }) {
      success
      message
    }
  }
`

export const UPDATE_USER = gql`
  mutation updateUser(
    $id: Int!
    $firstName: String
    $lastName: String
    $email: String
    $roles: [Int]
    $username: String
  ) {
    updateUser(
      id: $id
      input: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        roles: $roles
        username: $username
    }) {
      success
      message
    }
  }
`

export const UPDATE_SUPPLIER = gql`
  mutation updateSupplier(
    $id: Int!
    # $paymentId: Int
    $paymentType: PaymentTypes
    $paymentInfo: [SupplierBankInput]
    # $bankId: Int
    # $bankAccountType: BankAccountType
    # $bankAccountName: String
    # $bankAccountNumber: String
    # $prefix: String
    $name: String
    $taxId: String
    # $bankAccountName: String
    # $bankAccountNumber: String
    $isVat: Boolean
    $contactName: String
    $contactPhoneNumber: String
    $contactFaxNumber: String
    $contactEmail: String
    $contactLineId: String
    $contactFacebookName: String
    $contactRemark: String
    $creditTerm: Int
    # $creditLimit: Float
    # $creditUsage: Float
    $addressUrl: String
    $officeTel: String
  ) {
    updateSupplier(
      id: $id
      input: {
        paymentType: $paymentType
        paymentInfo: $paymentInfo
      #   paymentInfo:{
      #   id: $paymentId
      #   bankId: $bankId
      #   bankAccountType: $bankAccountType
      #   bankAccountName: $bankAccountName
      #   bankAccountNumber: $bankAccountNumber
      # }
        # prefix: $prefix
        name: $name
        taxId: $taxId
        officeTel: $officeTel
        # bankAccountName: $bankAccountName
        # bankAccountNumber: $bankAccountNumber
        isVat: $isVat
        contactName: $contactName
        contactPhoneNumber: $contactPhoneNumber
        contactFaxNumber: $contactFaxNumber
        contactEmail: $contactEmail
        contactLineId: $contactLineId
        contactFacebookName: $contactFacebookName
        contactRemark: $contactRemark
        creditTerm: $creditTerm
        # creditLimit: $creditLimit
        # creditUsage: $creditUsage
        addressUrl: $addressUrl
    }) {
      success
      message
    }
  }
`

export const UPDATE_CUSTOMER = gql`
  mutation updateCustomer(
    $id: Int!
    $paymentType: PaymentTypes
    $pricingTypeId: Int
    $bankId: Int
    $prefix: String
    $name: String
    $taxId: String
    $bankAccountName: String
    $bankAccountNumber: String
    $isVat: Boolean
    $contactName: String
    $contactPhoneNumber: String
    $contactFaxNumber: String
    $contactEmail: String
    $contactLineId: String
    $contactFacebookName: String
    $contactRemark: String
    $creditLimit: Float
    $creditUsage: Float
    $creditTerm: Int
  ) {
    updateCustomer(
      id: $id
      input: {
        paymentType: $paymentType
        pricingTypeId: $pricingTypeId
        bankId: $bankId
        prefix: $prefix
        name: $name
        taxId: $taxId
        bankAccountName: $bankAccountName
        bankAccountNumber: $bankAccountNumber
        isVat: $isVat
        contactName: $contactName
        contactPhoneNumber: $contactPhoneNumber
        contactFaxNumber: $contactFaxNumber
        contactEmail: $contactEmail
        contactLineId: $contactLineId
        contactFacebookName: $contactFacebookName
        contactRemark: $contactRemark
        creditLimit: $creditLimit
        creditUsage: $creditUsage
        creditTerm: $creditTerm
    }) {
      success
      message
    }
  }
`

export const CREATE_INVENTORY = gql`
  mutation createInventory(
    # $type: InventoryType!
    $supplierId: [Int]!
    $productName: String!
    $reference: String
    $barcode: String
    $sku: String!
    $brand: String
    $category: String
    $productGroup: ProductGroup!
    $tag: [TagInput]
    $stockType: StockType!
    $sellable: Boolean
    $purchasable: Boolean
    $taxable: Boolean
    $serialTracking: Boolean
    $inventoryOption: [InventoryOptionInput]
    $unit: String
    $technicianName: String
  ) {
    createInventory(
      input: {
        # type: $type
        supplierId: $supplierId
        productName: $productName
        sku: $sku
        barcode: $barcode
        reference: $reference
        brand: $brand
        category: $category
        productGroup: $productGroup
        tag: $tag
        stockType: $stockType
        sellable: $sellable
        purchasable: $purchasable
        taxable: $taxable
        serialTracking: $serialTracking
        inventoryOption: $inventoryOption
        unit: $unit
        technicianName: $technicianName
    }) {
      success
      message
    }
  }
`

export const CREATE_TIRE_INVENTORY = gql`
  mutation createInventoryForTire(
    $supplierId: [Int]!
    $productName: String!
    $reference: String
    $barcode: String
    $sku: String
    $brand: String
    $category: String
    $productGroup: ProductGroup!
    $tag: [TagInput]
    $stockType: StockType!
    $sellable: Boolean
    $purchasable: Boolean
    $taxable: Boolean
    $serialTracking: Boolean
    $inventoryOption: [InventoryOptionForTireInput]
    $model: String
    $tireTypeId: Int!
    $unit: String
    $technicianName: String
  ) {
    createInventoryForTire(
      input: {
        supplierId: $supplierId
        productName: $productName
        reference: $reference
        barcode: $barcode
        sku: $sku
        brand: $brand
        category: $category
        productGroup: $productGroup
        tag: $tag
        stockType: $stockType
        sellable: $sellable
        purchasable: $purchasable
        taxable: $taxable
        serialTracking: $serialTracking
        inventoryOption: $inventoryOption
        model: $model
        tireTypeId: $tireTypeId
        unit: $unit
        technicianName: $technicianName
      }) {
        success
        message
      }
  }
`

export const UPDATE_TIRE_INVENTORY = gql`
  mutation updateInventoryTire(
    $id: Int!
    $tag: [TagInput]
    $supplierId: [Int]
    $productName: String
    $productGroup: ProductGroup
    $reference: String
    $sku: String
    $brand: String
    $inventoryOption: [UpdateInventoryOptionInputForTire]
    $model: String
    $tireTypeId: Int
    $unit: String
    $technicianName: String
  ) {
    updateInventoryTire(id: $id, input: {
      tag: $tag
      supplierId: $supplierId
      productName: $productName
      productGroup: $productGroup
      reference: $reference
      sku: $sku
      brand: $brand
      inventoryOption: $inventoryOption
      model: $model
      tireTypeId: $tireTypeId
      unit: $unit
      technicianName: $technicianName
    }) {
      success
      message
    }
  }
`

export const ADJUST_STOCK = gql`
  mutation adjustStock(
    $adjustStockList: [AdjustStockListInput]
  ) {
    adjustStock (input: {
      adjustStockList: $adjustStockList
    }) {
      success
      message
    }
  }
`

export const TRANSFER_STOCK = gql`
  mutation transferStock(
    $sourceId: Int!
    $destinationId: Int!
    $itemId: Int!
    $quantityChange: Int!
    $reason: String
  ) {
    transferStock (input: {
      sourceId: $sourceId
      destinationId: $destinationId
      itemId: $itemId
      quantityChange: $quantityChange
      reason: $reason
    }) {
      success
      message
    }
  }
`

export const UPDATE_INVENTORY = gql`
  mutation updateInventory(
    $tag: [TagInput]
    $supplierId: [Int]
    $productName: String
    $productGroup: ProductGroup
    $reference: String
    $barcode: String
    $sku: String
    $brand: String
    $category: String
    # $sellable: Boolean
    # $purchasable: Boolean
    # $taxable: Boolean
    # $serialTracking: Boolean
    $inventoryOption: [UpdateInventoryOptionInput]
    $id: Int!
    $unit: String
    $technicianName: String
  ) {
    updateInventory (id: $id, input: {
      tag: $tag
      supplierId: $supplierId
      productName: $productName
      productGroup: $productGroup
      reference: $reference
      barcode: $barcode
      sku: $sku
      brand: $brand
      category: $category
      # sellable: $sellable
      # purchasable: $purchasable
      # taxable: $taxable
      # serialTracking: $serialTracking
      inventoryOption: $inventoryOption
      unit: $unit
      technicianName: $technicianName
    }) {
      success
      message
    }
  }
`

export const IMPORT_TIRE = gql`
  mutation ImportTireSerialNumber(
    $warehouseId: Int!
    $inventoryOptionId: Int!
    $files: Upload
  ) {
    ImportTireSerialNumber(input: {
      warehouseId: $warehouseId
      inventoryOptionId: $inventoryOptionId
      files: $files
    }) {
      success
      message
    }
  }
`

export const UPDATE_SERIAL = gql`
  mutation UpdateTireSerialNumber(
    $id: Int!
    $status: TireSerialNumberStatus
    $warehouseId: Int
    $serialNumber: String
  ) {
    UpdateTireSerialNumber(input: {
      id: $id
      status: $status
      warehouseId: $warehouseId
      serialNumber: $serialNumber
    }) {
      success
      message
    }
  }
`

export const CHANGE_SERIAL_NUMBER = gql`
  mutation ChangeTireSerialNumber(
    $id: Int!
    $serialNumber: String!
  ) {
    ChangeTireSerialNumber(input: {
      id: $id
      serialNumber: $serialNumber
    }) {
      success
      message
    }
  }
`

export const MULTIPLETRANSFER_TIRE = gql`
  mutation MultipleTransferStockSerialNumber(
    $ids: [Int]!            
    $inventoryOptionId: Int!
    $warehouseId: Int!
    $sourceWarehouseId: Int!
  ) {
    MultipleTransferStockSerialNumber(input: {
      ids: $ids      
      inventoryOptionId: $inventoryOptionId
      warehouseId: $warehouseId
      sourceWarehouseId: $sourceWarehouseId
    }) {
      success
      message
    }
  }
`
export const DELETE_PURCHASE_ORDER = gql`
  mutation DeletePurchaseOrder(
    $id: Int!
  ){
    DeletePurchaseOrder(input:{
      id: $id
    }){
      success
      message
    }
  }
`

export const CREATE_LEAVE = gql`
  mutation CreateLeave(
    $driverId: Int!
    $endDate: Date!
    $remark: String!
    $startDate: Date!
  ) {
    CreateLeave(input: {
      driverId: $driverId
      endDate: $endDate
      remark: $remark
      startDate: $startDate
    }) {
      success
      message
    }
  }
`
